import { createJSONStorage } from 'zustand/middleware';

export const ssrSafeStorage = createJSONStorage(() => {
    if (typeof window !== 'undefined') return window.localStorage;
    return {
        getItem: () => null,
        setItem: () => {},
        removeItem: () => {},
    };
});
